module.exports = __webpack_public_path__ + "static/img/sz02.c024a595.png";